export const addFullSectionMargin = () => {
	const sectionContainer = document.querySelector('.section-margin');
	sectionContainer.classList.add('section-margin-full');
};

export const removeFullSectionMargin = () => {
	const sectionContainer = document.querySelector('.section-margin');
	if (sectionContainer) {
		sectionContainer.classList.remove('section-margin-full');
	}
};

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/utils/handle-section-margin.js